import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { EMAIL_TEMPLATE_CONTROLLER } from "api/Service";

export const useEmailTemplatesAll = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["emailTemplatesAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
